/**
 * Handle products
 */
const
    body = $('body'),
    disclaimerBox = $('.cart--single #disclaimerBox'),
    disclaimerTrigger = $('.cart--single #disclaimerTrigger'),
    subscribeMode = $('.cart--single #subscribeMode');

//- Select Subscribe option if click on disclaimer box title
disclaimerTrigger.on("click", function () {
    let checkbox = $('.cart--single #subscribeCheckbox');
    let cartBtn = $('.cart--single #cartCta');

    checkbox.toggleClass('checked');
    cartBtn.toggleClass('disabled');
});

// close disclaimer box
$('.cart--single #closeDisclaimer').on('click', function () {
    disclaimerBox.removeClass('subscribe-box__disclaimer--open');
});

// Select Product Option - extended functionality to switch between products
$('.cart--single .product-switch__option').on('click', function () {
    let thisProduct = $(this);
    let thisProductAttr = thisProduct.attr('data-product-option');

    if (!thisProduct.hasClass('active')) {
        $('.cart--single .product-switch__option').removeClass('active');
        thisProduct.addClass('active');
    }

    //- assign the chosen product attr to its parent
    thisProduct.parent().attr('data-product', thisProductAttr);

    $('.cart--single .cart__product.active').trigger("click");
})

//- Handle Product Image and Ribbon
//- Shared function between cartSingleProduct and cartTogglesubscriptionMode components
function showProductAndRibbon(unit, badge) {
    // Images to show according to the product unit
    $('.cart__image-item').removeClass('show').addClass('hide');
    $('.cart__image-item--' + unit + "").removeClass('hide').addClass('show');

    //- prints Best value per package
    if ($('.ribbon').length) {
        $('.ribbon__value').html(badge);
    }
}

// Subscribe Mode
$('.cart--single .subscribe-box__default').on('click', function () {
    let thisBtn = $(this);
    let cartBtn = $('.cart--single #cartCta');
    let checkbox = $('.cart--single #subscribeCheckbox');

    $('.cart--single .subscribe-box__default').removeClass('active');
    thisBtn.addClass('active');

    disclaimerBox.addClass('subscribe-box__disclaimer--open');

    //- reset all UIs
    if (cartBtn.hasClass('disabled')) {
        cartBtn.removeClass('disabled');
    }

    if (checkbox.hasClass('checked')) {
        checkbox.removeClass('checked');
    }

    //- set 'data-subscribe' value + control UI
    if (thisBtn.hasClass('subscribe')) {
        subscribeMode.attr('data-subscribe', 'true');

        if (!cartBtn.hasClass('disabled')) {
            cartBtn.addClass('disabled');
        }

        if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.addClass('subscribe-box__disclaimer--open');
        }

    } else {
        subscribeMode.attr('data-subscribe', 'false');

        if (cartBtn.hasClass('disabled')) {
            cartBtn.removeClass('disabled');
        }

        if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.removeClass('subscribe-box__disclaimer--open');
        }
    }

    $('.cart--single .cart__product.active').trigger("click");
});

function activeProductCartSingleProduct() {
    let thisProduct = $(this);
    let subscribeAttr = $('.cart--single #subscribeMode').attr('data-subscribe');
    let chooseProductAttr = $('.cart--single #chooseProduct').attr('data-product');

    const retail = thisProduct.attr('data-retail');

    let price,
        regularity,
        link,
        subscribeSave,
        shipping,
        alternativeContentValue,
        badge,
        unit = thisProduct.attr('data-units');

    $('.cart--single .cart__products').removeClass(function (index, className) {
        return (className.match(/(^|\s)unit-\S+/g) || []).join(' ');
    }).addClass('unit-' + unit);


    if (thisProduct.attr('data-badge')) {
        badge = thisProduct.attr('data-badge');
    }

    if ($('.cart--single #chooseProduct').length && chooseProductAttr === 'optional') {
        if (subscribeAttr === 'true') {
            link = 'data-option-subscribe-tracker';

        } else {
            link = 'data-option-tracker';
        }

        $('.cart--single .cart__image-default').removeClass('show').addClass('hide');
        $('.cart--single .cart__image-optional').removeClass('hide').addClass('show');

    } else {
        if (subscribeAttr === 'true') {
            link = 'data-subscribe-tracker';

        } else {
            link = 'data-tracker';
        }

        $('.cart--single .cart__image-default').removeClass('hide').addClass('show');
        $('.cart--single .cart__image-optional').removeClass('show').addClass('hide');
    }

    if (subscribeAttr === 'true') {
        price = 'data-subscribe-amount';
        regularity = '<span>/month</span>';
        shipping = 'data-subscribe-shipping';
        alternativeContentValue = '';

        // $('.cart--single .current__value').html(thisProduct.attr(price) + '<span>/month</span>');

    } else {
        price = 'data-amount';
        regularity = '';
        shipping = 'data-shipping',
            alternativeContentValue = $('.cart--single #alternativeContent').attr('data-alt-content');

        // $('.cart--single .current__value').html(thisProduct.attr(price));
    }

    $('.cart--single .cart__product').removeClass('active');
    thisProduct.addClass('active');

    $('.cart--single .current__value').html(thisProduct.attr(price) + regularity);
    $('.cart--single .retail__value').html(retail);
    $('.cart--single .shipping__value').html((thisProduct.attr(shipping)));

    $('.cart--single #alternativeContent').html(' ' + alternativeContentValue);

    //- TECH-2158 - removal of Shipping Value
    //   if (unit == '3' || unit == '6' || unit == '1' && subscribeAttr === 'true') {
    //       if (!$('.cart--single .shipping').hasClass('hide')) {
    //           $('.cart--single .shipping').addClass('hide');
    //       }
    //   } else {
    //       $('.cart--single .shipping').removeClass('hide');
    //   }

    //- Update value if show FREE US SHIPPING on 1 Unit Continuity
    // if (unit == '1' && subscribeAttr === 'true') {
    //     subscribeSave = 'data-subscribe-save';

    //     $('.cart--single .saving__value').html(thisProduct.attr(subscribeSave));
    // } else {
    //     $('.cart--single .saving__value').html((retail - thisProduct.attr(price)).toFixed(2));
    // }


    $('.cart--single .saving__value').html((retail - thisProduct.attr(price)).toFixed(2));

    showProductAndRibbon(unit, badge);

    //- handle CTA by ID
    let param = $('.cart--single #cartCta').attr('data-param');
    $('.cart--single #cartCta').attr('href', thisProduct.attr(link) + param);
}

$('.cart--single .cart__product').on('click', activeProductCartSingleProduct);
$('.cart--single .cart__product.active').trigger("click");
